<div *ngIf="!preloader2" [hidden]="hidden" class="preloader-backdrop">
  <div class="page-preloader" [ngStyle]="preloaderStyle">{{ preloaderLabel }}</div>
</div>

<div *ngIf="preloader2" class="preloader2" [ngStyle]="containerStyle" [hidden]="preloader2Hidden">
  <div [ngStyle]="spinnerStyle"></div>
  <div [ngStyle]="spinnerStyle"></div>
  <div [ngStyle]="spinnerStyle"></div>
  <div [ngStyle]="spinnerStyle"></div>
</div>
